import React, { FunctionComponent } from 'react';

import { ConfigItem, ConfigItemType } from '../types';

import { ConfigItemElementProps } from './types';

type ConfigItemsTrayContextType = {
  configElements: Record<ConfigItemType, FunctionComponent<ConfigItemElementProps<ConfigItem>>>;
  /**
   * If true means, context is used for the multi edit insights page.
   */
  isMultiEditPage: boolean;
};

const ConfigItemsTrayContext = React.createContext<ConfigItemsTrayContextType>(null);

export { ConfigItemsTrayContext };
